<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="img" aria-hidden="true">
    <path
      fill="currentColor"
      d="M12.4 1.7c.3-.3.5-.4.9-.4s.7.1.9.4l9.3 9.3c.3.3.4.5.4.9s-.1.7-.4.9l-9.3 9.3c-.3.3-.5.4-.9.4s-.7-.1-.9-.4c-.3-.1-.4-.4-.4-.8s.1-.7.4-.9l7.1-7.1H1.3c-.4 0-.7-.1-.9-.4-.3-.2-.4-.5-.4-.9s.1-.7.4-.9.5-.4.9-.4h18.1l-7.1-7.1c-.2-.3-.3-.5-.3-.9s.1-.7.4-1z"
    />
  </svg>
</template>
